import { Constants } from "./Constants";
import { CoreFrameGrid } from "./index";
import { ColumnWidthHelper } from "./Components/ColumnWidthHelper";

interface IToResize {
    BodyEL: JQuery<HTMLElement>;
    TotalRowEL: JQuery<HTMLElement>;
    ResizerEL: JQuery<HTMLElement>;
    ColumnName: string;
}

export class ColumnResizer {
    private isPressed = false;
    private Start: JQuery<HTMLElement> = undefined;
    private StartX = undefined;
    private StartWidth = undefined;
    private ToResize: IToResize = {
        BodyEL: undefined,
        TotalRowEL: undefined,
        ResizerEL: undefined,
        ColumnName: undefined
    };
    private NS = Constants.EVENT_NAMESPACE;
    private UsingPercentWidth = false;

    constructor(private grid: CoreFrameGrid) {
        this.registerEvents();
    }

    private registerEvents() {
        this.grid.getHeader().getWrapper().on('mousedown.' + this.NS, 'div.' + Constants.CLASS_RESIZER, (e: JQuery.MouseDownEvent) => { this.onMouseDown(e) });
        this.grid.getHeader().getWrapper().on('dblclick.' + this.NS, 'div.' + Constants.CLASS_RESIZER, (e: JQuery.DoubleClickEvent) => { this.onDoubleClick(e) });
    }

    private checkIsUsingPercent(id:string) {
        let indices = id.split('-'); // ROWINDEX - COLINDEX
        const rowIndex = parseInt(indices[0]);
        const colIndex = parseInt(indices[1]);

        const headerColumn = this.grid.getHeader().getHeaderRows()[rowIndex][colIndex];
        const indexInAllColumns = this.grid.getAllVisibleLeafColumns().indexOf(headerColumn);

        let th = this.grid.getHeader().theadRows[rowIndex].children().eq(colIndex)[0] as HTMLElement;
        let col = this.grid.getHeader().$colgroup.eq(0).children().eq(indexInAllColumns)[0] as HTMLElement;
        let w = col.style.width;
        if (w.indexOf('%') >= 0) {
            this.UsingPercentWidth = true;
            col.style.width = th.offsetWidth + "px";
        }
    }

    private restoreWhenUsingPercent() {
        if (this.UsingPercentWidth) {
            // TODO => Prozentuale Breite wiederherstellen
            // Evt. muss man jedoch auch alle anderen spalten umwandeln...
        }
        this.UsingPercentWidth = false;
    }

    private onMouseDown(ev: JQuery.MouseDownEvent<HTMLElement, null>) {
        ev.preventDefault();
        ev.stopPropagation();
        const id = this.getIdFromEvent(ev);
        const col = this.grid.getHeader().getHeaderColById(id);
        const index = this.grid.getAllVisibleLeafColumns().indexOf(col);
        this.ToResize.ColumnName = this.getColumnNameFromEvent(ev);
        this.ToResize.BodyEL = $(this.grid.getBody().$colgroup[0].children[index]) as JQuery<HTMLElement>;
        if(this.grid.getOptions().hasTotalRow)
            this.ToResize.TotalRowEL = $(this.grid.getTotalRow().$colgroup[0].children[index]) as JQuery<HTMLElement>;
        this.ToResize.ResizerEL = $(ev.currentTarget);
        this.checkIsUsingPercent(id);
        this.Start = $(this.grid.getHeader().$colgroup[0].children[index]) as JQuery<HTMLElement>;

        this.isPressed = true;
        this.StartX = ev.pageX;
        this.StartWidth = this.Start.width();

        ColumnWidthHelper.addOrRemoveFittedClass(this.grid, index, col, false);

        $(document).on('mousemove.' + this.NS, e => this.onMouseMove(e as any));
        $(document).on('mouseup.' + this.NS, e => this.onMouseUp());
    }

    private getIdFromEvent(event: JQuery.MouseDownEvent){
        let $target = $(event.currentTarget);
        return $target.data('id');
    }

    private getColumnNameFromEvent(event: JQuery.MouseDownEvent | JQuery.DoubleClickEvent){
        let $target =$(event.currentTarget);
        return $target.data('columnname');
    }

    private onMouseMove(ev: JQuery.MouseMoveEvent<HTMLElement, null>) {
        if (this.isPressed) {
            this.resizeElements(this.StartWidth + (ev.pageX - this.StartX));
        }
    }

    private onDoubleClick(ev: JQuery.DoubleClickEvent<HTMLElement, null>) {
        const columnName = this.getColumnNameFromEvent(ev);

        this.setMaxWidth(columnName);
    }

    public setMaxWidth(columnName: string): void {
        let col = this.grid.getAllVisibleLeafColumns().filter(c => c.name == columnName)[0]; 
                
        let maxWidth = ColumnWidthHelper.calcMaxWidth(this.grid, col, this.grid.getBody().getAllValuesForColumn(col));
        this.setWidth(columnName, maxWidth);
    }

    public setWidth(columnName: string, width: string | number, withoutEventPropagation: boolean = false): void {
        const leafColumns = this.grid.getAllVisibleLeafColumns();
        let col = leafColumns.filter(c => c.name == columnName)[0];

        const index = leafColumns.indexOf(col);
        const headerColElement = $(this.grid.getHeader().$colgroup[0].children[index]) as JQuery<HTMLElement>;
        const bodyColElement = $(this.grid.getBody().$colgroup[0].children[index]) as JQuery<HTMLElement>;
                    
        headerColElement.width(width);
        bodyColElement.width(width);

        if(this.grid.getOptions().hasTotalRow){
            const totalRowColElement = $(this.grid.getTotalRow().$colgroup[0].children[index]) as JQuery<HTMLElement>;
            totalRowColElement.width(width);
        }

        this.rearrangeResizer([]);
        this.restoreWhenUsingPercent();
        if (!withoutEventPropagation) {
            this.grid.onColumnResized(columnName, bodyColElement.width());
        }
    }

    private onMouseUp() {
        if (this.isPressed) {
            this.isPressed = false;
            this.rearrangeResizer([]);
            this.restoreWhenUsingPercent();

            $(document).off('mousemove.' + this.NS);
            $(document).off('mouseup.' + this.NS);
            this.grid.onColumnResized(this.ToResize.ColumnName, this.ToResize.BodyEL.width());
        }
    }

    public rearrangeResizer(columnWidths: number[]) {
        const header = this.grid.getHeader();
        const columns = this.grid.getAllVisibleLeafColumns().filter(c => header.isColumnResizable(c));
        const allResizer = header.getAllResizer();
        const theadRows = header.theadRows;

        let allWidth = 0;
        for (let index = 0; index < columns.length; index++) {
            const columnCoordinates = header.getHeaderRowColIndexAndRowIndex(columns[index]);

            const theadRow = theadRows[columnCoordinates.row];
            if (!theadRow) {
                break;
            }
            const th = theadRow.find('th').eq(columnCoordinates.col);
            const offsetWidth = ($(th)[0] as HTMLTableHeaderCellElement).offsetWidth;
            
            if (offsetWidth == 0) {
                // check if any width got calculated
                const calc = columnWidths[index];
                const columnWidth = columns[index].width;
                
                if (!columnWidth && calc) {
                    allWidth += calc;
                } else {
                    allWidth += parseInt(columnWidth + "");
                }
            } else {
                allWidth += offsetWidth;
            }
            const res = allResizer.filter(`[data-id="${columnCoordinates.row}-${columnCoordinates.col}"]`)[0];
            res.style.left = (allWidth - 5) + 'px';
            res.style.top = th[0].offsetTop + 'px';

            // Fallback to 25px to have any resizable indicator
            const resizerHeight = th.height() ? th.height() : 25;
            res.style.height = resizerHeight + 'px';
            res.style.position = 'absolute';
            res.style.width = '10px';
            res.style.cursor = 'col-resize';
        }
    }

    private resizeElements(newWidth) {
        if (newWidth > this.grid.getOptions().colMinWidth) {
            this.Start.width(newWidth);
            this.ToResize.BodyEL.width(newWidth);
            this.ToResize.TotalRowEL?.width(newWidth);
        }
    }
}